import type {ExtractPropsWithoutRef} from '@/types';

import {FilterCustomerRatingItems} from '@/components/FilterCustomerRatingItems';
import {FilterTile} from '@/modules/common/components/Filter/FilterTile';

type FilterTileProps = Pick<
  ExtractPropsWithoutRef<typeof FilterTile>,
  'helpArticle' | 'selectedFiltersCount' | 'caption'
>;

type ItemsProps = ExtractPropsWithoutRef<typeof FilterCustomerRatingItems>;

type Props = ExtractPropsWithoutRef<'div'> &
  FilterTileProps & {
    options: ItemsProps['items'];
    canShowOptionBestPrice: ItemsProps['canShowOptionBestPrice'];
    onChange: ItemsProps['onChange'];
  };

export const RatingFilter = ({
  options,
  canShowOptionBestPrice,
  onChange,
  ...restProps
}: Props) => {
  return (
    <FilterTile {...restProps}>
      <FilterCustomerRatingItems
        items={options}
        canShowOptionBestPrice={canShowOptionBestPrice}
        onChange={onChange}
      />
    </FilterTile>
  );
};
